<!--
 * @Author: wangjx
 * @LastEditors: wangjx
 * @Date: 2022-02-25 14:24:43
 * @LastEditTime: 2022-03-09 15:07:29
 * @Description: file content
-->
<template>
  <div id="permission_config">
    <!-- 左边树结构 -->
    <div class="left_tree_box drag-left-layout pt-2" :class="{ 'hidden_content': hiddenLeftTree }">
      <div class="move_box" @click="hiddenLeftTree = !hiddenLeftTree">
        <svg-icon icon-class="collapse-border" class="move_collapse"></svg-icon>
        <svg-icon icon-class="collapse-border-active" class="move_collapse_active"></svg-icon>
      </div>
      <div class="mt-2 pl-4 pr-4">
        <el-input
          v-model="leftSearchText"
          class="self-filter-input"
          placeholder="搜索"
          clearable
          @keyup.enter.native="leftFilterTree"
          @input="leftFilterTree"
          @clear="leftFilterTree"
        >
          <i slot="suffix" class="pr-2" @click="leftFilterTree">
            <svg-icon icon-class="input_search"></svg-icon>
          </i>
        </el-input>
      </div>

      <span class="vertical-bar fnM ml-4">授权对象</span>
      <el-tree
        ref="leftTree"
        style="height: calc(100% - 138px)"
        class="self-tree data_tree mt-4 overflow-y-auto"
        node-key="id"
        :props="leftDefaultProps"
        :data="leftTreeData"
        :highlight-current="true"
        :filter-node-method="filterNode"
        :default-expanded-keys="leftDefaultShowNodes"
        :expand-on-click-node="false"
        @node-click="leftHandleNodeClick"
        @node-expand="leftHandleNodeExpand"
        @node-collapse="leftHandleNodeCollapse"
      >
        <span slot-scope="{ node }" :title="node.label" class="self-custom-tree leading-8">
          <span class="pr-2">
            <span v-html="leftHandleFilter(node.label)"></span>
          </span>
        </span>
      </el-tree>
    </div>
    <!-- 中间树结构 -->
    <div class="tree_content">
      <div class="right_content">
        <div class="w100">
          <el-tabs v-model="periodSelected" class="pt-2 ml-5 mr-5 period-tabs">
            <el-tab-pane
              v-for="item in periodList"
              :key="item.value"
              :label="item.label"
              :name="item.value"
            ></el-tab-pane>
          </el-tabs>
        </div>

        <div class="w100 tree">
          <apFunction
            v-if="periodSelected === 'function'"
            class="h100"
            :target-id="leftCurrentNode.id"
            :target-type="targetType"
          ></apFunction>
          <apField
            v-if="periodSelected === 'field'"
            class="h100 pl-5"
            :target-id="leftCurrentNode.id"
            :target-type="targetType"
          ></apField>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataApi from "@/api/data-permission/dataPermission";
import { mapGetters } from "vuex";
import { commonFilterNode } from "@/utils";
import apField from "@/views/standard/permission/components/assign-permission-field.vue";
import apFunction from "@/views/standard/permission/components/assign-permission-function.vue";

export default {
  name: "PermissionConfig",
  components: {
    apField,
    apFunction
  },
  props: {},
  data() {
    return {
      targetType: "2",
      leftSearchText: "",
      leftFilterText: "",
      hiddenLeftTree: false,
      leftDefaultProps: {
        children: "children",
        label: "roleName"
      },
      leftTreeData: [],
      leftCurrentNode: "",
      leftDefaultShowNodes: [],
      periodSelected: "function",
      periodList: [
        {
          label: "菜单权限",
          value: "function"
        },
        {
          label: "页面资源权限",
          value: "field"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["tenantId"])
  },
  created() {
    const that = this;
    window.onresize = function () {
      if (document.body.clientWidth < 1400) {
        that.hiddenLeftTree = true;
      }
    };
    this.getFirstTreeList();
    // this.getCenterTreeList();
  },
  methods: {
    // 获取最左边树结构
    async getFirstTreeList() {
      dataApi.getRoleList({}).then(res => {
        this.leftDefaultProps.label = "roleName";
        if (res && res.success) {
          this.leftTreeData = res.data;
          this.$nextTick(() => {
            if (!this.leftCurrentNode && res.data.length) {
              const [node] = this.leftTreeData;
              this.leftCurrentNode = node;
              this.leftDefaultShowNodes.push(node.id);
            }
            this.$refs.leftTree && this.$refs.leftTree.setCurrentKey(this.leftCurrentNode.id);
          });
        }
      });
    },
    handleUserData(data, userList) {
      for (let g = 0; g < data.length; g++) {
        if (data[g] && data[g].userIds) {
          for (let i = 0; i < data[g].userIds.length; i++) {
            for (let j = 0; j < userList.length; j++) {
              if (data[g].userIds[i] === userList[j].id) {
                const userInfo = {
                  id: data[g].userIds[i],
                  orgId: data[g].userIds[i],
                  orgName: userList[j].displayName
                };
                if (data[g].children) {
                  data[g].children.unshift(userInfo);
                } else {
                  data[g].children = [];
                  data[g].children.push(userInfo);
                }
                break;
              }
            }
          }
        }
        if (data[g].children && data[g].children.length) {
          data[g].children = this.handleUserData(data[g].children, userList);
        }
      }
      return data;
    },

    // 手动高亮筛选文本
    leftHandleFilter(str) {
      if (!this.leftFilterText || !str) {
        return str;
      }
      const index = str.indexOf(this.leftFilterText);
      const beforeStr = str.substr(0, index);
      const afterStr = str.substr(index + this.leftFilterText?.length);
      if (index > -1) {
        return `${beforeStr}<span style="color:#00B259;">${this.leftFilterText}</span>${afterStr}`;
      } else {
        return str;
      }
    },
    handleFilter(str) {
      if (!this.centerFilterText || !str) {
        return str;
      }
      const index = str.indexOf(this.centerFilterText);
      const beforeStr = str.substr(0, index);
      const afterStr = str.substr(index + this.centerFilterText?.length);
      if (index > -1) {
        return `${beforeStr}<span style="color:#00B259;">${this.centerFilterText}</span>${afterStr}`;
      } else {
        return str;
      }
    },
    // 筛选树
    leftFilterTree() {
      this.leftFilterText = this.leftSearchText;
      this.$refs.leftTree.filter(this.leftSearchText);
    },
    filterTree() {
      this.centerFilterText = this.centerSearchText;
      this.$refs.centerTree.filter(this.centerSearchText);
    },
    // 节点筛选
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    // 树节点展开
    leftHandleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.leftDefaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.leftDefaultShowNodes.push(data.id);
      }
    },
    leftHandleNodeCollapse(data) {
      this.leftDefaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.leftDefaultShowNodes.length = i;
        }
      });
    },
    handleNodeExpand(data) {
      // 保存当前展开的节点
    },
    handleNodeCollapse(data) {},
    // 节点点击
    leftHandleNodeClick(node) {
      if (node.orgType && ["DEPARTMENT", "ORGANIZATION"].includes(node.orgType)) {
        this.$message.error("不能选择部门节点！");
        return;
      }
      this.leftCurrentNode = node;
      console.log(this.leftCurrentNode.id);
    },
    handleNodeClick(node) {
      this.centerCurrentNode = node;
      this.tableData = [];
      if (node.ac && !this.isLockAction) {
        this.getFieldList();
      }

      /*
       * this.getResourceDetail();
       * this.getDetailList();
       */
    }
  }
};
</script>

<style scoped lang="scss">
#permission_config {
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  .left_tree_box {
    position: relative;
    flex: 0 224px;
    width: 224px;
    transition: all 0.25s linear;
    background-color: #f9f9fb;
    .data_tree {
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      .el-icon-more {
        transform: rotate(90deg);
      }
    }
    .data_tree::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  .hidden_content {
    margin-left: -224px;
    flex: inherit;
  }
  .fade-left-enter-active,
  .fade-left-leave-active {
    transition: all 0.2s ease-in;
    flex: 0 224px;
  }

  .fade-left-enter-from,
  .fade-left-leave-to {
    flex: 0 0;
  }
  .tree_content {
    display: flex;
    flex: 1;
    transition: all 0.2s ease-in;
    position: relative;
    min-width: calc(100% - 224px);
    .right_content {
      flex: 1;

      height: 100%;
      width: calc(100% - 224px);
      transition: all 0.6s ease-in;
      .search_box {
        margin-bottom: 16px;
        line-height: 32px;
        overflow: hidden;
      }
      .danger_button {
        color: #f56c6c;
      }
    }
  }

  .move_box {
    position: absolute;
    right: -34px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 50px;
    z-index: 99;
    cursor: pointer;
    .move_collapse {
      display: block;
    }

    .move_collapse_active {
      display: none;
    }

    &:hover {
      .move_collapse {
        display: none;
      }
      .move_collapse_active {
        display: block;
      }
    }
  }
}
</style>

<style lang="scss">
#permission_config {
  .self-filter-input {
    margin-bottom: 20px;
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
    .el-input__icon {
      color: #9da5b2;
      line-height: 32px;
    }
  }
  .tree {
    height: calc(100% - 59px);
  }
  .el-radio-button {
    .el-radio-button__inner {
      padding: 8px 10px;
      width: 103px;
      font-size: 12px;
    }
  }
  .period-tabs {
    .el-tabs__header {
      margin: 0;
    }
  }
}
</style>
